import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * ActionButtons Component - Reusable edit/delete/view action buttons
 *
 * @example
 * <app-molecule-action-buttons
 *   [showEdit]="true"
 *   [showDelete]="true"
 *   [showView]="false"
 *   (edit)="editItem(item)"
 *   (delete)="deleteItem(item)">
 * </app-molecule-action-buttons>
 */
@Component({
  selector: 'app-molecule-action-buttons',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
})
export class ActionButtonsComponent {
  // Inputs
  showView = input<boolean>(false);
  showEdit = input<boolean>(true);
  showDelete = input<boolean>(true);
  viewTitle = input<string>('View');
  editTitle = input<string>('Edit');
  deleteTitle = input<string>('Delete');

  // Outputs
  view = output<void>();
  edit = output<void>();
  delete = output<void>();
}
